import * as React from 'react';
import FilesTableView from '../layouts/FilesTableView';
import { MaterialData, DesignData, TatData, ManufacturerData, BranchData } from 'src/reducers/fileUpload';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { UserDetail } from 'src/reducers/user';
// import Slide from '@material-ui/core/Slide';
// import { TransitionProps } from '@material-ui/core/transitions';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// function SlideTransition(props: TransitionProps) {
//     return <Slide {...props} direction="down" />;
// }

export interface FilesTableProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;

    deleteRowbyId: () => void;
    onUploadAllFiles: () => void;
    onClearAllFiles: () => void;
    onRefreshStatus: () => void;
    onClearAllUploaded: () => void;

    files2: Array<File>;
    onFilesChange2: () => void;
    onFilesError2: () => void;
    progress: Array<number>;
    sending: boolean;

    onSelectFile: () => void;
    onSelectAllFile: () => void;
    orderDataDesign: DesignData[];
    orderDataTat: TatData[];
    orderDataMaterial: MaterialData[];
    orderDataManufacturer: ManufacturerData[];

    orderDataBranch: BranchData[];
    branchType: string;

    saveMaterialType: () => void;
    saveTatType: () => void;
    saveDesignType: () => void;
    saveMessegeOrder: () => void;
    saveManufactType: () => void;
    saveDesignSoftware: () => void;
    saveOrderModel: () => void;
    saveDesignApproval: () => void;
    saveIsBravo: () => void;

    saveBranchType: (branchType: string) => void;

    errorMessage: string;
    errorBar: boolean;
    successMessage: string;
    successBar: boolean;
    handleCloseRemovefiles: () => void;

    errorFileUploadedOpen: boolean;
    errorfilemsg: string;
    successFileUploadOpen: boolean;
    successfilemsg: string;
    handleClose: () => void;

    userDetails: UserDetail;
    saveDrPreferences: () => void;
    saveBookingId: () => void;

}

class FilesTable extends React.Component<FilesTableProps> {
    render() {
        return (
            <div>
                <FilesTableView
                    files2={this.props.files2}
                    deleteRowbyId={this.props.deleteRowbyId}
                    onUploadAllFiles={this.props.onUploadAllFiles}
                    onClearAllFiles={this.props.onClearAllFiles}
                    onRefreshStatus={this.props.onRefreshStatus}
                    onClearAllUploaded={this.props.onClearAllUploaded}
                    onFilesChange2={this.props.onFilesChange2}
                    onFilesError2={this.props.onFilesError2}
                    orderDataDesign={this.props.orderDataDesign}
                    orderDataTat={this.props.orderDataTat}
                    orderDataMaterial={this.props.orderDataMaterial}
                    orderDataManufacturer={this.props.orderDataManufacturer}
                    orderDataBranch={this.props.orderDataBranch}
                    branchType={this.props.branchType}
                    saveMaterialType={this.props.saveMaterialType}
                    saveTatType={this.props.saveTatType}
                    saveDesignType={this.props.saveDesignType}
                    saveMessegeOrder={this.props.saveMessegeOrder}
                    saveManufactType={this.props.saveManufactType}
                    saveDesignSoftware={this.props.saveDesignSoftware}
                    saveOrderModel={this.props.saveOrderModel}
                    saveDesignApproval={this.props.saveDesignApproval}
                    saveIsBravo={this.props.saveIsBravo}
                    saveBranchType={this.props.saveBranchType}
                    onSelectFile={this.props.onSelectFile}
                    onSelectAllFile={this.props.onSelectAllFile}
                    progress={this.props.progress}
                    sending={this.props.sending}
                    userDetails={this.props.userDetails}
                    saveDrPreferences={this.props.saveDrPreferences}
                    saveBookingId={this.props.saveBookingId}
                />
                {/* <------------------------------------------------------Error Message---------------------------------> */}
                {/* <Snackbar
                    open={this.props.errorFileUploadedOpen}
                    autoHideDuration={3000}
                    transitionDuration={1000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                        onClose={this.props.handleClose}
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorfilemsg}
                    </Alert>
                </Snackbar> */}
                {/* <------------------------------------------------------Success Message---------------------------------> */}
                {/* <Snackbar
                    open={this.props.successFileUploadOpen}
                    autoHideDuration={3000}
                    transitionDuration={1000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                        onClose={this.props.handleClose}
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successfilemsg}
                    </Alert>
                </Snackbar> */}
                {/* <------------------------------------------------------Error Message---------------------------------> */}
                <Snackbar
                    open={this.props.errorBar}
                    onClose={this.props.handleCloseRemovefiles}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                        onClose={this.props.handleCloseRemovefiles}
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorMessage}
                    </Alert>
                </Snackbar>
                {/* <------------------------------------------------------Success Message---------------------------------> */}
                <Snackbar
                    open={this.props.successBar}
                    onClose={this.props.handleCloseRemovefiles}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                        onClose={this.props.handleCloseRemovefiles}
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successMessage}
                    </Alert>
                </Snackbar>
            </div>

        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }
}

export default FilesTable;



// WEBPACK FOOTER //
// ./src/components/filesTable/FilesTable.tsx